import { Component, OnInit, Inject } from '@angular/core';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { OAuthService } from 'angular-oauth2-oidc';
import {Router} from '@angular/router';
import { NxModalRef } from '@aposin/ng-aquila/modal';

@Component({
	selector: 'app-progress-dialog',
	templateUrl: './progress-dialog.component.html',
	styleUrls: ['./progress-dialog.component.scss'],
})
export class ProgressDialogComponent{
	showTechnicalError: boolean = false;
	constructor(private oauthService: OAuthService, private router: Router, @Inject(NX_MODAL_DATA) readonly data: any,
		 private readonly modalRef: NxModalRef<ProgressDialogComponent>) {
		
	}

	toggleTechnicalError() {
		this.showTechnicalError = !this.showTechnicalError;
	}

	getTrackerDetails(): string {
		return '';
	}

	closeDialog(): void {
		// Optionally pass data back
		this.modalRef.close('Dialog closed programmatically');
	}

}
